module.exports = __webpack_public_path__ + "static/media/nonord-c-1.f5f67a07.mp3";